<template>
  <div class="form-container">
    <div v-for="item in column" :key="item.field" class="row-edit-form-item">
      <el-col class="label-col" :span="colSpan[0]" :style="labelStyle">
        {{ item.label }}
      </el-col>
      <el-col class="field-col" :span="colSpan[1]">
        <slot :name="item.field" :formData="formData">
          <div v-if="detailForm" class="info-content">
            {{item.formatter ? item.formatter(formData) : formData[item.field]}}
          </div>
          <!--     弹窗编辑     -->
          <row-editor
            v-if="popoverEdit"
            v-bind="{...$attrs, ...item}"
            :fieldInfo="{ fieldLabel: item.label, fieldName: item.field}"
            :row="editConfig.params"
            :edit-url="editConfig.url"
            :field-style="{color: formData[item.field] || formData[item.field] === 0 ? '#3C3C3C' : '#DD1144'}"
            @detailUpdate="handleUpdate"
          ></row-editor>
          <!--     行编辑     -->
          <row-edit
            v-else
            v-model="formData[item.field]"
            v-bind="{...$attrs, ...item}"
            :field-name="item.field"
            :row="editConfig.params"
            :edit-url="editConfig.url"
            @onUpdate="handleUpdate()"
          />
        </slot>
      </el-col>
    </div>
  </div>
</template>
<script>
import RowEdit from "@/components/matrix/row-edit.vue";
import {getRequest} from "@/api/matrixApi";
import RowEditor from "@/components/matrix/row-editor.vue";

export default {
  name: "row-edit-form",
  components: {RowEditor, RowEdit},
  props: {
    dataList: {
      type: Object,
      default: () =>({})
    },
    searchConfig: Object, // {url, params}
    editConfig: Object, // {url, params}
    column: { // {label, field, ...attr}
      type: Array,
      default: () => []
    },
    colSpan: {
      type: Array, // [label, field]
      default: () => [4, 8]
    },
    labelStyle: Object,
    detailForm: Boolean, // 详情模式
    popoverEdit: Boolean, // 弹窗编辑
  },
  data() {
    return {
      formData: {}
    }
  },
  mounted() {
    this.getFormData()
  },
  methods: {
    getFormData() {
      if (!this.searchConfig) return
      const {url, params} = this.searchConfig
      getRequest(url, params).then(res => {
        this.formData = res.data.data
        this.$emit('searchCb', res)
      })
    },
    // 字段修改完成回调
    handleUpdate() {
      this.$emit('handleUpdate', this.formData)
    }
  },
  watch: {
    dataList: {
      handler(val) {
        this.formData = val
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #dcdcdc;

.form-container {
  margin-top: 20px;
  border: $border;
  border-left: 0;
  border-bottom: 0;
  font-size: 14px;

  .el-col {
    height: 40px;
    margin: 0;
    line-height: 40px;
    text-align: center;
  }

  .label-col {
    border: $border;
    border-top: 0;
  }

  .field-col {
    border-bottom: $border;
  }

  ::v-deep .info-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:after {
    content: '';
    display: block;
    clear: both;
  }
}
</style>
